var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AppLayoutSkeleton',{staticClass:"app-layout",scopedSlots:_vm._u([{key:"banner",fn:function(){return [_c('img',{staticClass:"app-layout__logo",attrs:{"src":_vm.logo}})]},proxy:true},{key:"header",fn:function(){return [_c('AppLocaleSwitch')]},proxy:true}])},[_c('RouterView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }